import React, { Component } from 'react';
import AddRubroExcept from './AddRubroExcept.jsx';
import AddRubroOnly from './AddRubroOnly.jsx';


let rubrosListExcept;
let rubrosListOnly;

class RadioButtonRubros extends Component {
    constructor(props) {
        super(props);
        this.filtroRubro = this.filtroRubro.bind(this);
        this.selectRubro = this.selectRubro.bind(this);
    }

    filtroRubro(e) {
        let typeInput = e.target.id;
        let isCheck = e.target.checked;
        this.props.filtroRubro(typeInput, isCheck);
    }

    selectRubro(event) {
        let typeInput = event.target.id;
        let term = event.target.value;
        this.props.selectRubro(typeInput, term);
    }

    render() {
        let rubroExcept;
        let rubroOnly;
        let rubrosNodesExcept;
        let rubrosNodesOnly;
        let typeInput;
        let i;

        if (this.props.data != undefined && this.props.data != "") {
            rubrosNodesExcept = this.props.data.GET_RUBROS_FILTER_EXCEPT.map(function (row) {
                return (
                    <option Id={row.Id} value={row.Descripcion} key={"Rubros_" + row.Id} />
                );
            });

            rubrosNodesOnly = this.props.data.GET_RUBROS_FILTER_ONLY.map(function (row) {
                return (
                    <option Id={row.Id} value={row.Descripcion} key={"Rubros_" + row.Id} />
                );
            });

            let me = this;

            if (this.props.data.rubroExcept != undefined) {
                rubrosListExcept = this.props.data.rubroExcept.map(function (row) {
                    typeInput = row.typeInput != undefined ? row.typeInput : 'inputAllExcept';
                    return (
                        <AddRubroExcept
                            key={"RubroExcept" + row.Id}
                            Id={row.Id}
                            Descripcion={row.Descripcion}
                            TypeInput={typeInput}
                            removeRubro={me.props.removeRubro}
                        />
                    );
                });
            }

            if (this.props.data.rubroOnly != undefined) {
                rubrosListOnly = this.props.data.rubroOnly.map(function (row) {
                    typeInput = row.typeInput != undefined ? row.typeInput : 'inputOnly';
                    return (
                        <AddRubroOnly
                            key={"RubroOnly" + row.Id}
                            Id={row.Id}
                            Descripcion={row.Descripcion}
                            TypeInput={typeInput}
                            removeRubro={me.props.removeRubro} />
                    );
                });
            }
        }

        let firstSelectedClass = this.props.data.rdFirstCheck == true ? "selected" : null;
        let secondSelectedClass = this.props.data.rdSecondCheck == true ? "selected" : null;

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Rubros en los que puede comprar</label>
                        </div>
                    </div>
                    <div className="row top-separator-xs">
                        <div className={"col-xs-12 bottom-padding-xs " + firstSelectedClass}>
                            <div className="row">
                                <div className="col-md-2" key={this.props.key} >
                                    <div className="container-radio radio-margin" style={{ paddingLeft: "20px" }}>
                                        <input
                                            id="radioAll"
                                            className="jqvalid"
                                            type="radio"
                                            name="rubro"
                                            checked={this.props.data.rdFirstCheck}
                                            value={this.props.data.enabledExcept}
                                            onChange={this.filtroRubro}
                                            required />
                                        <label className="label-secondary" htmlFor="radioAll" style={{ marginTop: "10px"}}>Todos</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-5">
                                    <ul className="no-bullets no-padding no-margin">
                                        <li className="inlineListItem2 lg-margin">
                                            <div className="default-checkbox">
                                                <input
                                                    id="CheckAllExcept"
                                                    type="checkbox"
                                                    checked={this.props.data.checked}
                                                    disabled={!this.props.data.enabledExcept}
                                                    onChange={this.filtroRubro} />
                                                <label htmlFor="CheckAllExcept"></label>
                                            </div>
                                        </li>
                                        <li className="inlineListItem2">
                                            <label className="label-secondary" htmlFor="CheckAllExcept">Excepto</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="row" >
                                <div className="col-xs-5">
                                    <div class="input-icon-container">
                                        <span className="ti-search input-icon-span"></span>
                                        <input
                                            id="inputAllExcept"
                                            className="form-control input-with-icon"
                                            list="listRubrosExcept"
                                            placeholder="Buscar rubros para excluir"
                                            disabled={!this.props.data.disabled}
                                            value={this.props.data.valueExcept}
                                            onChange={this.selectRubro} />
                                    </div>
                                    <datalist id="listRubrosExcept">
                                        {rubrosNodesExcept}
                                    </datalist>
                                </div>
                            </div>
                            <div className="top-separator-xs">
                                <ul className="no-bullets no-padding no-margin">
                                    {rubrosListExcept}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row top-separator-xs">
                        <div className={"col-xs-12 bottom-padding-xs " + secondSelectedClass}>
                            <div className="row">
                                <div className="col-xs-2" key={this.props.key} >
                                    <div className="container-radio radio-margin"  style={{ paddingLeft: "20px" }}>
                                        <input
                                            id="radioOnly"
                                            type="radio"
                                            name="rubro"
                                            className="jqvalid"
                                            checked={this.props.data.rdSecondCheck}
                                            value={this.props.data.enabledOnly}
                                            onChange={this.filtroRubro}                                            
                                            required />
                                        <label className="label-secondary" htmlFor="radioOnly" style={{ marginTop: "10px" }}>Solamente</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-5">
                                    <div className="input-icon-container">
                                        <span className="ti-search input-icon-span"></span>
                                        <input
                                            id="inputOnly"
                                            className="form-control input-with-icon"
                                            list="listRubrosOnly"
                                            placeholder="Buscar rubros para incluir"
                                            disabled={!this.props.data.enabledOnly}
                                            onChange={this.selectRubro}
                                            value={this.props.data.valueOnly} />
                                    </div>
                                    <datalist id="listRubrosOnly">
                                        {rubrosNodesOnly}
                                    </datalist>
                                </div>
                            </div>
                            <div className="row top-separator-xs">
                                <div className="col-xs-5">
                                    <ul className="no-bullets no-padding no-margin">
                                        {rubrosListOnly}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div><div className="row">
                        <div className="col-md-12">
                            {this.props.data.ERROR_EMPRESA["seleccionoTipoRubro"] == false ? <label className="error">Debe seleccionar al menos una opción.</label> : null}
                            {this.props.data.ERROR_EMPRESA["seleccionoRubro"] == false ? <label className="error">Debe seleccionar al menos un rubro.</label> : null}
                        </div>
                    </div>
                </div>
            </div>
        );

    }
};

export default RadioButtonRubros;